import { CheckCircleOutlined } from '@ant-design/icons';
import { Col, Row, Tooltip,Spin,Card,Badge } from 'antd';
import React, { Component } from 'react';
import { initPreviewForScan } from "../../../action/preview_status.action";
import { connect } from "react-redux";
import {updateBannerState}  from '../../../action/c240_loader.action'

class InSlideState extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        if (this.props.red){
            return <Badge color="red" />;
        }else{
            return <Badge color="grey" />;
        }
    }
};


class CassetteBarcodeState extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let cassette_barcode_state = [];
        if (this.props.barcodeTaken === true) {
            cassette_barcode_state.push(<Badge key={"0"} status="success" />);
        } else {
            cassette_barcode_state.push(<Badge key={"1"} status="default" />);
        }
        return cassette_barcode_state;
    }
};

class GatePrompt extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadings:this.props.loadings,
            listOfRemovedTasks : []            

        }
    }

    componentDidMount = () => {
        if (this.props.cassetteSize === 1 || this.props.cassetteSize === 2) {
            this.props.handleProgressChange(1);
        }
        if (this.props.prompt === "REMOVED_TASKS_PROMPT"){
            let _listOfRemovedTasks = this.state.listOfRemovedTasks
            this.props.removedtasks.map((cassette) => {
                _listOfRemovedTasks.push("R"+cassette["rack"]+"T"+cassette["tray"]+"S"+cassette["slide"])
            })
            this.setState({
                listOfRemovedTasks: _listOfRemovedTasks
            });
        }
    }

    componentDidUpdate = (prevProps) => {
        if (prevProps.previews === undefined 
            && this.props.previews) {
            this.props.dispatch(initPreviewForScan());
        }
    }

    closePrompt = (e) => {
        e.stopPropagation()
        if (this.props.prompt === "OPEN_GATE_PROMPT") {
            this.props.dispatch(updateBannerState(false));
            this.props.openGate();
        } else if (this.props.prompt === "CLOSE_GATE_PROMPT") {
            this.props.closeGate();
        } else if (this.props.prompt === "REMOVED_TASKS_PROMPT") {
            this.props.removedTaskConfirmation();
        }
    }

    taskTitle = (taskType) => {
        if (taskType === "TAKE_SLIDE_PREVIEW"){
            return "Preview of "
        }else if(taskType === "TAKE_AUTO_SCAN"){
            return "Auto Scan of "
        }else if(taskType === "TAKE_SCAN_OF_SELECTED_REGION"){
            return "Scan of "
        }else if(taskType === "OPEN_GATE"){
            return "GATE WILL BE OPENED "
        }else{
            return taskType.replace(/_/g," ")
        }

    }

    isPromptBtnDisabled = (prompt) => {
        if (prompt === "OPEN_GATE_PROMPT") {
            return this.props.loadings["user_interaction_start"];
        } else if (prompt === "CLOSE_GATE_PROMPT") {
            return this.props.loadings["user_interaction_end"];
        }
        return false;
    }

    render() {
        let disablePromptBtn = this.isPromptBtnDisabled(this.props.prompt);
        let textInfo = <Col></Col>
        let racks_table = [];
        if(this.props.prompt === "REMOVED_TASKS_PROMPT"){
            // textInfo = this.props.removedtasks.map((cassette) => {
            //     return <Col span={5} >
            //     {`${this.taskTitle(cassette["taskType"])}R${cassette["rack"] === 0 ? 2 : cassette["rack"]}T${cassette["tray"]+1}S${cassette["slide"]+1}`}
            //     </Col>
            // })
            let listOfRemovedTasks = []
            this.props.removedtasks.map((cassette) => {
                listOfRemovedTasks.push("R"+cassette["rack"]+"T"+cassette["tray"]+"S"+cassette["slide"])
            })
            let listOfAffectedCassettes = [];
            this.props.removedtasks.map((cassette) => {
                if (!listOfAffectedCassettes.includes("R"+cassette["rack"]+"T"+cassette["tray"])) {
                    console.debug("affected cassette: " + "R"+cassette["rack"]+"T"+cassette["tray"]);
                    listOfAffectedCassettes.push("R"+cassette["rack"]+"T"+cassette["tray"]);
                }
            })
            let slots = [0, 1, 2, 3, 4, 5];
            for (let i = 1; i >= 0; i--) {
                let toolTipPosition = i === 0 ? "right" : "left";
                let thisrack = [];
                for (let j = 19; j >= 0; j--) {
                    const key = `R${i}T${j}`;
                    thisrack.push(
                        <Row key={key}>
                            <Card 
                                className="zero-padded-ant-card-body"
                                bodyStyle={{ padding: "4px !important" }}
                                bordered={true}
                                style={
                                    listOfAffectedCassettes.includes(key) ? 
                                    {
                                    border: `solid red`,
                                    borderWidth: "3 px",
                                    padding: "2px !important",
                                    marginTop:"2px"
                                    }:{
                                    borderLeft: `solid #B0B0B0`,
                                    borderWidth: "3 px",
                                    padding: "2px !important",
                                    marginTop:"2px"
                                    }
                                }>                                
                            <Row>
                                <Tooltip placement={toolTipPosition} title={
                                    <div>
                                        <Row style={{ display: "flex"}}>
                                            <Col span={24}> {"Slot " + (i === 0 ? "R" : "L") + (j+1)} </Col>
                                        </Row>
                                    </div>} color="#2db7f5" >
                                    <div >
                                        <Col span={8} style={{fontSize:'0.7vw',paddingLeft:'0.4vw'}} >
                                        {j+1}
                                        </Col>
                                    </div>
                                    {/* <div style={{ marginLeft:"15px"}}>
                                        {slots.map((value) => {return <Col key={value.toString()} span={2}>
                                            <InSlideState red={listOfRemovedTasks.includes((key+"S"+value))}></InSlideState>
                                        </Col>})}
                                    </div> */}
                                </Tooltip>
                            </Row>


                            </Card>

                        </Row>
                );    
                }
                racks_table.push(<Col key={`rack-${i}`} offset={0} style={{marginLeft: "4px"}} span={11} ><span >Rack {i==1?"L":"R"}</span>{thisrack}</Col>);
            }

        }
        return (
            // <div style={{padding: '5px'}}>
            <Row key={0} className="rounded-container load-slides-message-div" style={this.props.prompt === "REMOVED_TASKS_PROMPT" ?{height: '800px'}:{height: '500px'}}>
                    <Col className="scan-workflow-init" span={24}>
                    <Spin spinning={this.props.c240LoaderState.show_loader} 
                        tip={this.props.prompt === "OPEN_GATE_PROMPT" ?
                             "Opening the Gate" 
                             : this.props.prompt === "CLOSE_GATE_PROMPT" ? 
                                "Closing Gate. Please wait" : null} size="large">
                    <Row style={{ fontSize: 20 }} className="arial-font">
                        <div>
                            <Row>
                                {/* {this.props.prompt.replace(/_/g," ")} */}
                                { this.props.prompt === "OPEN_GATE_PROMPT" ? <Row style={{ fontWeight: 'bold' }}>GATE IS CURRENTLY CLOSED</Row> : null }
                                { this.props.prompt === "CLOSE_GATE_PROMPT" ? <Row style={{ fontWeight: 'bold' }}>GATE IS CURRENTLY OPEN</Row> : null }
                            </Row>
                            <br />
                            <Row>
                            { this.props.prompt === "OPEN_GATE_PROMPT" ? 
                            <Row>
                                <Row>Click the button to Open the Gate</Row>
                                <Row>This will allow you to insert the Cassettes.</Row>
                                <br/>
                                    {/* was added when we were recoding entire rack video and processing at the end */}
                                    {/* <Row style={{ color: "gray" }}>
                                        <Row>After the gate opens, try to close gate within 30 minutes.</Row>
                                        <Row>If it might take more than 30 minutes to prepare the Cassettes, don't Open Gate now,</Row>
                                        <Row>first prepare Cassettes, then Open Gate, load the Cassettes and then Close the Gate.</Row>
                                    </Row> */}
                            </Row>
                            : null }
                            { this.props.prompt === "CLOSE_GATE_PROMPT" ? 
                                <Row>
                                    <Row>Close the Gate once you have inserted the Cassettes.</Row>
                                    <Row>Closing the gate will resume any previously queued Preview or Scan for untouched Cassettes.</Row>
                                    {/* <Row>Any inserted or replaced Cassettes will be auto queued for previews.</Row> */}
                                    <br/>
                                    {/* was added when we were recoding entire rack video and processing at the end */}
                                    {/* <Row style={{ color: "gray" }}>
                                        <Row>Please try to close gate within 30 minutes.</Row>
                                        <Row>If it might take more than 30 minutes to prepare the Cassettes, you should Close Gate now,</Row>
                                        <Row>then prepare Cassettes, then Open Gate, load the Cassettes and then Close the Gate.</Row>
                                    </Row> */}
                                </Row>
                                : null }
                            { this.props.prompt === "REMOVED_TASKS_PROMPT" ? 
                                <Row>
                                    <Row>Scans or previews for these cassettes have been removed from Queue.</Row>
                                    <Row>These cassettes were either removed or replaced.</Row>
                                </Row>
                             : null }
                            </Row>
                            <br />
                            {/* {textInfo} */}
                            <Row  style={{paddingLeft: "30%",paddingRight: "30%"}} >
                            {racks_table}
                            </Row>
                            {/* { this.props.prompt === "REMOVED_TASKS_PROMPT" ? 
                                <Row>Any inserted or replaced Cassettes have automatically been queued for preview.</Row>
                             : null } */}
                            <Row>
                            </Row>
                        </div>
                    </Row>
                    <br></br>
                    <Row style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Tooltip title="Click here when done" placement="rightTop">
                            <Col span={4} 
                                className="promt-done-button" 
                                style={disablePromptBtn ? { cursor: "not-allowed", opacity: "0.3" } : {}} 
                                onClick={(e) => {if (disablePromptBtn) {return;} this.closePrompt(e)}}>
                                <Row style={{ color: "#26A65B" }}>
                                    <CheckCircleOutlined style={{ fontSize: 50 }}/>
                                </Row>
                                <Row className="arial-font">{ this.props.prompt === "OPEN_GATE_PROMPT" ? "Open Gate" : this.props.prompt === "CLOSE_GATE_PROMPT" ? "Close Gate" : "OK" }</Row>
                            </Col>
                        </Tooltip>
                    </Row>
                    </Spin>
                </Col>
            </Row>
            // </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        c240LoaderState: state.c240LoaderReducer,
        previews : state.previewStatusReducer,
    };
};

export default connect(mapStateToProps)(GatePrompt);